import axios from 'axios'
import Cookies from 'js-cookie'
import tokenRefresher from './token-refresher'

const baseURL = import.meta.env.VITE_BASE_URL

export const axiosInstance = axios.create({
    baseURL,
    headers: {
        'Content-Type': 'application/json',
    },
})

axiosInstance.interceptors.request.use(async config => {
    const clienteTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const token = Cookies.get('JWT')

    if (clienteTimezone && config.headers) {
        config.headers['x-timezone'] = clienteTimezone
    }

    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`
    }

    if (config.headers) config.headers['x-platform'] = 'web'

    return config
})

axiosInstance.interceptors.response.use(
    response => {
        if (
            ['application/pdf', 'application/octet-stream'].includes(
                response.headers['content-type'],
            )
        )
            return response?.data
        return response?.data?.data
    },

    async error => {
        // Não teve resposta
        if (!error.response)
            return Promise.reject({
                message: 'Erro ao comunicar com o servidor',
            })

        // Não foi UnauthorizedException
        if (error.response.status !== 401)
            return Promise.reject(error.response.data ?? error.response)

        // Check if we're already on the login page to avoid redirect loops
        const isLoginPage = ['', '/'].includes(window.location.pathname)

        // Erro ao autenticar
        if (
            ['/v1/auth/session', '/v1/auth/refresh'].includes(
                error.response.data?.path,
            )
        ) {
            tokenRefresher.logoff(!isLoginPage)
            return Promise.reject(error.response.data)
        }

        // Token expirado
        return tokenRefresher.refreshToken().then(token => {
            if (token) {
                const config = error.config
                config.headers.Authorization = `Bearer ${token}`
                return axiosInstance.request(config)
            }
            tokenRefresher.logoff(!isLoginPage)
        })
    },
)
